var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_notification",
    transform: "translate(-1699 -67.583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    transform: "translate(1699 67.583)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1711,90.667a2.334,2.334,0,0,1-2.334-2.334h-7a1.174,1.174,0,0,1-.824-.342,1.158,1.158,0,0,1-.342-.824A1.168,1.168,0,0,1,1701.666,86V77.833a9.333,9.333,0,0,1,18.667,0V86a1.176,1.176,0,0,1,.825.342,1.168,1.168,0,0,1,0,1.65,1.175,1.175,0,0,1-.825.342h-7a2.319,2.319,0,0,1-.683,1.65A2.346,2.346,0,0,1,1711,90.667Zm0-19.833a6.952,6.952,0,0,0-4.95,2.05,7.045,7.045,0,0,0-2.05,4.949V86h14V77.833a7.048,7.048,0,0,0-2.049-4.949A6.958,6.958,0,0,0,1711,70.834Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.ffd0894e.svg";
export { ForwardRef as ReactComponent };